module.exports = __webpack_public_path__ + "img/arrow-right.510b6a88.png";